module.exports = __webpack_public_path__ + "static/media/IndustryLeader001.1b81ae36.png";